import * as React from 'react';
import { FormGroup, Input } from 'reactstrap';
import { StringFilterEditProps } from '../providers/SingleValue';
import FilterEditRequiredValidation from './FilterEditRequiredValidation';
import { FiltersListAddButton } from './index';

interface BooleanFilterEditState {
	value: string;
	displayValidationError: boolean;
}

/**
 * Configures a boolean filter
 */
class BooleanFilterEdit extends React.PureComponent<StringFilterEditProps, BooleanFilterEditState> {
	constructor(props) {
		super(props);

		// we need to store state locally as we will modify the state depending on whether
		// the field is nullable or not, to avoid giving users a choice they can't make.
		this.state = {
			value: 'true',
			displayValidationError: false,
		};
	}

	/**
	 * Updates local state when the selection is made and lets the parent know that state needs to be updated.
	 *
	 * @private
	 * @memberof BooleanFilterEdit
	 */
	private handleOnChange = (e: React.ChangeEvent<HTMLInputElement>) => {
		const newValue = e.currentTarget.value;
		this.setState({ value: newValue });
	};

	/**
	 * Handles form submit.
	 *
	 * @private
	 * @memberof BooleanFilterEdit
	 */
	private handleSubmit = () => {
		const trimmedValue = this.state.value.trim();

		const validationError = !this.props.filter.nullable && !trimmedValue;

		this.setState({
			displayValidationError: validationError,
		});

		if (validationError) {
			return;
		}

		this.props.onChange(this.state.value, false);
	};

	public render() {
		return (
			<FormGroup>
				<Input id="fieldValue" type="select" autoFocus value={this.state.value} onChange={this.handleOnChange}>
					{this.props.filter.nullable ? <option value="">&lt;Empty&gt;</option> : null}
					<option value="true">Yes</option>
					<option value="false">No</option>
				</Input>
				<div className="filters-popover__actions">
					<FiltersListAddButton onClick={this.handleSubmit} />
				</div>
				{this.state.displayValidationError ? (
					<FilterEditRequiredValidation messageOverride="Field is required" />
				) : null}
			</FormGroup>
		);
	}
}

export default BooleanFilterEdit;
